export default __webpack_public_path__ + "images/3c53506571bd3218df70f6abc5831de2.png";